<template>
<div></div>
</template>
<script>
export default {
    mounted() {
        let params = {

        }
        this.$store.dispatch('auth/logout' , params)
        .then(() => {
            this.$router.push({ path: '/login' });
        }).catch(error => {
            this.$router.push({ path: '/login' });
        })
    }
}
</script>